'use strict'

import React, {Component} from 'react';
import {Row} from 'react-flexbox-grid';
import firebase from '../app/firebaseConnection';
import Judges from '../app/getJudges';
import Upload from '../app/uploadFiles'
import '../styles/App.css';

class Ideas extends Component {

  render() {
    return (
      <div>
        <section className="section">
          <h1 className="homeTitle">Modalidad de participación: Ideas de negocios</h1>
          <Row className="descriptionRow">
            <div className="newspaper">
              <p className="descriptionParagraph">
              Una presentación estructurada de una idea de negocios que se desea
              emprender, donde hay un alto grado de participación e interacción con
              expertos en la materia que les estarán dando retroalimentación
              acerca de sus ideas y las oportunidades reales que podrían tener
              con las mismas. Esta experiencia les permitirá desarrollar y
              mejorar técnicas, habilidades y/o competencias profesionales.
              Los interesados deben enviar su idea con el formato y nombre que se
              indica en <a href="https://firebasestorage.googleapis.com/v0/b/compdes2018-5dcda.appspot.com/o/businessIdeas%2FFormato%20idea%20de%20Innovadora.docx?alt=media&token=23045d4d-70d9-4526-823a-99d7f8acc7d4">
               ESTE DOCUMENTO</a> y recibirán posteriormente la indicación de la hora en que estará programada su
              exposición. Cada presentación y análisis con expertos tendrá una
              duración aproximada de 15 minutos. Por cada idea el proponente o un
              miembro del equipo proponente deben presentar en 5 minutos
              usando una presentación su idea y en los siguientes 10 minutos
              un equipo de expertos conformado por tres personas les realizará
              una serie de preguntas de análisis y retroalimentación sobre su idea.
              <br/>*Para enviar su idea diríjase a <a href="#sendIdeas">esta sección.</a>
              </p>
            </div>
          </Row>
          <h1 className="homeTitle tabsTitle">Equipo de expertos</h1>
          <div className="descriptionRow">
            <Judges/>
          </div>
          <div className="sendIdeas" id="sendIdeas">
            <h1 className="sendIdeas">¡Enviar mi idea!</h1>
            <Upload/>
          </div>
        </section>
      </div>
    );
  };
}

export default Ideas;



// WEBPACK FOOTER //
// ./src/ideas/ideas.js